module.exports = __webpack_public_path__ + "static/media/Stock.cfa859e7.png";